import * as React from 'react';

function SvgArrowRight(props) {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			height='1em'
			viewBox='0 0 24 24'
			width='1em'
			className='svg-icon'
			{...props}>
			<path d='M0 0h24v24H0V0z' fill='none' />
			<path d='M10 17l5-5-5-5v10z' />
		</svg>
	);
}

export default SvgArrowRight;
